import React, { useState, useCallback, useEffect } from "react";
import { Modal } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./styles.css";

export default function ImageZoomModal({ visible, images, currentIndex, onClose, title }) {
  const [idx, setIdx] = useState(currentIndex ?? 0);
  const [zoomed, setZoomed] = useState(false);
  const [zoomOrigin, setZoomOrigin] = useState("50% 50%");

  useEffect(() => {
    setIdx(currentIndex ?? 0);
    setZoomed(false);
  }, [currentIndex, visible]);

  const handleMouseMove = useCallback((e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setZoomOrigin(`${x}% ${y}%`);
  }, []);

  const prev = () => { setIdx((i) => Math.max(0, i - 1)); setZoomed(false); };
  const next = () => { setIdx((i) => Math.min(images.length - 1, i + 1)); setZoomed(false); };

  if (!images || images.length === 0) return null;

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={680}
      className="image-zoom-modal"
      centered
      title={title}
    >
      <div className="izm-container">
        {images.length > 1 && (
          <button className="izm-nav izm-nav-left" onClick={prev} disabled={idx === 0}>
            <LeftOutlined />
          </button>
        )}

        <div
          className={`izm-image-wrapper${zoomed ? " is-zoomed" : ""}`}
          onMouseEnter={() => setZoomed(true)}
          onMouseLeave={() => setZoomed(false)}
          onMouseMove={handleMouseMove}
        >
          <img
            src={images[idx]}
            alt={`${title} ${idx + 1}`}
            className="izm-image"
            style={{ transformOrigin: zoomOrigin }}
          />
        </div>

        {images.length > 1 && (
          <button className="izm-nav izm-nav-right" onClick={next} disabled={idx === images.length - 1}>
            <RightOutlined />
          </button>
        )}
      </div>

      {images.length > 1 && (
        <>
          <p className="izm-counter">{idx + 1} / {images.length}</p>
          <div className="izm-thumbnails">
            {images.map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`miniatura ${i + 1}`}
                className={`izm-thumb${i === idx ? " active" : ""}`}
                onClick={() => { setIdx(i); setZoomed(false); }}
              />
            ))}
          </div>
        </>
      )}

      <p className="izm-hint">Passe o mouse sobre a imagem para ampliar</p>
    </Modal>
  );
}
